module.exports = __webpack_public_path__ + "static/media/placeholder.0b3c604e.svg";